import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useMessagesStore = create(
  persist(
    (set, get) => ({
      threads: [],
      
      ensureThread: ({ userEmail, supplierId, supplierName }) => {
        const threads = get().threads
        let thread = threads.find(t => 
          t.userEmail === userEmail && t.supplierId === supplierId
        )
        
        if (!thread) {
          thread = {
            id: `th_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            userEmail,
            supplierId,
            supplierName,
            messages: [
              {
                id: `m_${Date.now()}`,
                text: 'Hallo! Wie können wir Ihnen helfen?',
                sender: 'supplier',
                timestamp: new Date().toISOString()
              }
            ],
            createdAt: new Date().toISOString(),
            unreadCount: 0
          }
          
          set({ threads: [thread, ...threads] })
        }
        
        return thread
      },
      
      sendMessage: (threadId, text, sender = 'user') => {
        set((state) => ({
          threads: state.threads.map(thread => {
            if (thread.id === threadId) {
              const message = {
                id: `m_${Date.now()}`,
                text,
                sender,
                timestamp: new Date().toISOString()
              }
              
              return {
                ...thread,
                messages: [...thread.messages, message],
                unreadCount: sender === 'user' ? thread.unreadCount : thread.unreadCount + 1
              }
            }
            return thread
          })
        }))
        
        // Simulate supplier response after delay
        if (sender === 'user') {
          setTimeout(() => {
            const threads = get().threads
            const thread = threads.find(t => t.id === threadId)
            if (thread) {
              const responses = [
                'Vielen Dank für Ihre Anfrage! Wir melden uns binnen 24 Stunden mit einem Angebot.',
                'Ihre Anfrage ist bei uns eingegangen. Wir prüfen die Verfügbarkeit und kommen auf Sie zurück.',
                'Vielen Dank für Ihr Interesse! Wir erstellen Ihnen gerne ein individuelles Angebot.'
              ]
              const randomResponse = responses[Math.floor(Math.random() * responses.length)]
              
              set((state) => ({
                threads: state.threads.map(t => {
                  if (t.id === threadId) {
                    const message = {
                      id: `m_${Date.now()}`,
                      text: randomResponse,
                      sender: 'supplier',
                      timestamp: new Date().toISOString()
                    }
                    return {
                      ...t,
                      messages: [...t.messages, message]
                    }
                  }
                  return t
                })
              }))
            }
          }, 3000)
        }
      },
      
      getThreadsByUser: (userEmail) => {
        return get().threads
          .filter(thread => thread.userEmail === userEmail)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      },
      
      markThreadAsRead: (threadId) => {
        set((state) => ({
          threads: state.threads.map(thread =>
            thread.id === threadId ? { ...thread, unreadCount: 0 } : thread
          )
        }))
      },
      
      getUnreadCount: (userEmail) => {
        return get().threads
          .filter(thread => thread.userEmail === userEmail)
          .reduce((total, thread) => total + thread.unreadCount, 0)
      }
    }),
    {
      name: 'messages-storage',
    }
  )
)